//@ts-check
import React from 'react';
import useFormAPI from '../api';
import apiClients from '../../../../utils/apiClients';

var FormScripts = function FormScripts() {
  var formApi = useFormAPI();
  React.useEffect(function () {
    var state = formApi.state,
        searchFields = formApi.searchFields;
    var workspace = state.options.workspace;
    var ids = searchFields({
      type: 'script'
    }).map(function (f) {
      return f.id;
    });
    ids.forEach(function (id) {
      var field = state.fields[id];
      if (field.type !== 'script') return;
      var script = field.script,
          src = field.src;
      getScript(workspace, src, script).then(function (content) {
        //this closure avoids poluting namespace with user variables
        window['ecrion'] = window['ecrion'] || {};
        var scriptContent = "window.ecrion[\"custom_form_script_".concat(id, "\"] = function() { ").concat(content, " }");
        var scriptElement = document.createElement('script');
        scriptElement.setAttribute('id', id);
        scriptElement.innerText = scriptContent;
        document.head.append(scriptElement);
        window['ecrion']["custom_form_script_".concat(id)].call("");
      }, function () {});
    });
    return function cleanup() {
      ids.forEach(function (id) {
        var scriptElement = document.getElementById(id);
        if (scriptElement) document.head.removeChild(scriptElement);
        if (window && window['ecrion'] && window['ecrion']["custom_form_script_".concat(id)]) delete window['ecrion']["custom_form_script_".concat(id)];
      });
    };
  }, []);
  return null;
};
/**
 * @return {Promise<string>}
 */


var getScript = function getScript(workspace, src, script) {
  if (!script && !src) return Promise.resolve('');
  if (script) return Promise.resolve(script);
  return apiClients.content.getContent(workspace, src);
};

export default FormScripts;